import type { IconSvgObject } from './types';

const ChevronsRightIcon: IconSvgObject = [
  ["path", { d: "M13 7L18 12L13 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 7L11 12L6 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsRightIcon;
